import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

function AddExperienceModal({ isOpen, onClose, onSave, type, initialData }) {
  const [title, setTitle] = useState("");
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  const titleRef = useRef(null);
  const [error, setError] = useState("");
  const [showTips, setShowTips] = useState(false);
  const tooltipRef = useRef(null);

  // Tips content for each section
  const tipsContent = {
    intro: "Write a short and clear introduction that highlights your background.",
    expertise: "Focus on your unique skills, achievements, and what sets you apart.",
    experience: "Mention only relevant years of professional experience clearly.",
    recognition: "Highlight your awards, certifications, or key career milestones."
  };


  // Config for each type
  const typeConfig = {
    intro: {
      heading: "Tell us more about yourself",
      placeholder: "About Yourself",
      field: "title",
      inputType: "text",
      showTitle: false,
    },
    expertise: {
      heading: "Showcase your expertise",
      placeholder: "I have been...",
      field: "about_me",
      inputType: "textarea",
      showTitle: true,
    },
    experience: {
      heading: "How many years of experience?",
      placeholder: "5 years",
      field: "total_year_of_experience",
      inputType: "number", // number input for years
      showTitle: false,
    },
    recognition: {
      heading: "Add a career highlight",
      placeholder: "I have been...",
      field: "qualification",
      inputType: "textarea",
      showTitle: false,
    },
  };

  const config = typeConfig[type] || typeConfig.intro;

  // Pre-fill data when modal opens
  useEffect(() => {
    if (initialData && config.field) {
      setValue(initialData[config.field] || "");
    }
    if (initialData?.title) {
      setTitle(initialData.title);
    }
  }, [isOpen, type, initialData]);

   useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  // Add this effect
useEffect(() => {
  if (!isOpen) {
    setShowTips(false); // ✅ Modal close hote hi tips bhi close ho jaaye
  }
}, [isOpen]);

  // outside click to close tooltip
  useEffect(() => {
    function handleClickOutside(e) {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setShowTips(false);
      }
    }

    if (showTips) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTips]);


  if (!isOpen) return null; // don’t render if closed

  const handleSave = (e) => {
    e.preventDefault();
     // ✅ validation: required field check
     if (config.field !== "qualification") {
    if (config.showTitle && !title.trim()) {
      toast.error("Title is required");
      inputRef.current?.focus();

      return;
    }
    if (!value.trim()) {
      toast.error("This field cannot be empty");
      inputRef.current?.focus();
      return;
    }
  }

   

    const payload = {
      ...(config.showTitle && { title }),
      [config.field]: value,
    };

     const existing = JSON.parse(localStorage.getItem("hostData")) || {};
  const updated = { ...existing, ...payload };
  localStorage.setItem("hostData", JSON.stringify(updated));

    onSave(payload);
    onClose();
  };

    




  return (
    <div className="modal-backdrop all_modalss others">
      <div className="modal-container">
        <h3>{config.heading}</h3>
        <button className="closes" onClick={onClose}>
          <i class="fa fa-times"></i>
        </button>
        <form onSubmit={handleSave}>
          <div className="form-group">
            
            {type === "experience" ? (
              <input
                type="text"
                ref={inputRef}
                placeholder={config.placeholder}
                value={value}
                // onChange={(e) => setValue(e.target.value)}
                onChange={(e) => {
      const onlyNumbers = e.target.value.replace(/[^0-9]/g, ""); // remove all non-numeric
      setValue(onlyNumbers);
    }}
                min="0"
                onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={2}
              />
            ) : (
              <textarea
              ref={inputRef}
                placeholder={config.placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                maxLength={300}
              />
            )}
          </div>
           {error && <p className="error-message">{error}</p>}

          <div className="modal-actions">
            <div className="tooltip-wrapper" ref={tooltipRef} onMouseEnter={() => setShowTips(true)}   // hover par open
  onMouseLeave={() => setShowTips(false)}>
            <button type="button" className="othr_links" onClick={() => setShowTips(!showTips)} >
              Get tips
            </button>

            {showTips && (
      <div className="tooltip-box">
        {tipsContent[type]}
        <span
          className="close-tooltip"
          onClick={() => setShowTips(false)}
        >
          
        </span>
      </div>
    )}
    </div>
            <button type="submit" className="submmits_links">
              Save
            </button>
          </div>
        </form>
      </div>
      <style jsx>{`
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal-container {
          background: white;
          padding: 20px;
          width: 350px;
          border-radius: 10px;
        }
        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
        }
        .btn {
          padding: 8px 15px;
          border-radius: 5px;
          cursor: pointer;
        }
        .btn-primary {
          background: #007bff;
          color: white;
        }
        .btn-secondary {
          background: #ccc;
          color: black;
        }
          .tooltip-wrapper {
    position: relative;
    display: inline-block;
  }
  .tooltip-box {
    position: absolute;
    bottom: 120%;  /* 👈 button ke upar dikhane ke liye */
    // left: 50%;
    // transform: translateX(-50%);
    background: #333;
    color: #fff;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    white-space: normal;
    width: 220px;
    text-align: left;
    z-index: 100;
  }
  .tooltip-box::after {
    content: "";
    position: absolute;
    top: 100%; /* 👈 neeche arrow */
    left: 15%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }
  .close-tooltip {
    margin-left: 8px;
    cursor: pointer;
    font-weight: bold;
  }
      `}</style>
    </div>
  );
}

export default AddExperienceModal;
